import React from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { FaCheck, FaRegCopy } from "react-icons/fa";
import { inviteServices } from "../../../APIServices/UserData/inviteServices";
import { useState } from "react";
import { useEffect } from "react";
import Moment from "react-moment";
import { FaXmark } from "react-icons/fa6";
import Swal from "sweetalert2";

const InviteData = ({ invitationId, getInvitation }) => {
  const [loader, setLoader] = useState(false);
  const [invitationData, setInvitationData] = useState("");

  const getSingleInvitationData = async () => {
    setLoader(true);
    let data = await inviteServices.getSingleInvitationData(invitationId);
    setInvitationData(data?.data || []);
    setLoader(false);
  };

  const copyEmail = (email) => {
    navigator.clipboard.writeText(email);
  };

  const resendInvitation = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Resend this Invitation?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, resend it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = invitationId;
        let data = await inviteServices.resendInvitation(userData);
        if (data?.statusCode === 200) {
          getInvitation();
          getSingleInvitationData();
        }
      }
    });
  };

  const cancelInvitation = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Cancel this Invitation?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, cancel it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = invitationId;
        let data = await inviteServices.cancelInvitation(userData);
        if (data?.statusCode === 200) {
          getInvitation();
          getSingleInvitationData();
        }
      }
    });
  };

  useEffect(() => {
    if (invitationId) {
      getSingleInvitationData();
    }
  }, [invitationId]);

  return (
    <Container fluid className="mt-2">
      <Row className="justify-content-center">
        <Form.Group as={Col} xxl={6} xl={8} lg={10} md={12} sm={12}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <div className="mb-4 hstack justify-content-between">
                <h5 className="m-0">Invitation Details</h5>
                {invitationData.status === "pending" && (
                  <div className="d-flex gap-2">
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="hstack gap-1 rounded-1"
                      style={{ fontSize: 10 }}
                      onClick={cancelInvitation}
                    >
                      <FaXmark /> Cancel
                    </Button>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="hstack gap-1 rounded-1"
                      style={{ fontSize: 10 }}
                      onClick={resendInvitation}
                    >
                      <FaCheck /> Resend
                    </Button>
                  </div>
                )}
              </div>

              <div className="d-flex flex-column gap-3">
                <div className="hstack justify-content-between">
                  <span className="text-muted">Email</span>
                  <div className="hstack gap-2">
                    <strong>{invitationData.email}</strong>
                    <FaRegCopy
                      className="cursor-pointer text-muted"
                      title="Copy email"
                      onClick={copyEmail}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Invited By</span>
                  <strong>{invitationData.invitedByName}</strong>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Invitation Date | Time</span>
                  <strong>
                    <Moment format="DD MMM YYYY | HH:mm" withTitle>
                      {invitationData?.invitationDate}
                    </Moment>
                  </strong>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">
                    Accept / Reject Date | Time
                  </span>
                  <strong>
                    {invitationData.acceptRejectDate ? (
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {invitationData?.invitationDate}
                      </Moment>
                    ) : (
                      "_"
                    )}
                  </strong>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Assign Designation</span>
                  <strong>{invitationData.designation}</strong>
                </div>
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Status</span>
                  <Badge
                    className="rounded-1 text-capitalize"
                    bg={
                      invitationData.status === "accepted"
                        ? "success"
                        : invitationData.status === "rejected"
                          ? "danger"
                          : "warning text-dark"
                    }
                  >
                    {invitationData.status}
                  </Badge>
                </div>
                <div className="d-flex justify-content-between gap-5">
                  <span className="text-muted text-nowrap">
                    Assign Accounts
                  </span>
                  <div className="d-flex flex-wrap gap-1">
                    {(invitationData?.totalAccount || [])?.map((item) => (
                      <Badge bg={`primary`} className="rounded-1">
                        {item?.name}
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Form.Group>
      </Row>
    </Container>
  );
};

export default InviteData;
